export const MOCK_DATAS = [
  {
    machine: '생산량(Ton)',
    data: [
      {
        date: '2024-08-13', // 유효한 날짜 형식
        category: '일목표량',
        PM2: 100,
        PM3: 120,
        합계: 220,
      },
      {
        date: '2024-08-13', // 유효한 날짜 형식
        category: '실생산량',
        PM2: 90,
        PM3: 115,
        합계: 205,
      },
      {
        date: '2024-08-13', // 유효한 날짜 형식
        category: '과부족',
        PM2: -10,
        PM3: -5,
        합계: -15,
      },
      {
        date: '2024-08-13', // 유효한 날짜 형식
        category: '이론생산량',
        PM2: 190,
        PM3: 240,
        합계: 430,
      },
      {
        date: '2024-08-13', // 유효한 날짜 형식
        category: '제품율(%)',
        PM2: 190,
        PM3: 240,
        합계: 430,
      },
      {
        date: '2024-08-13', // 유효한 날짜 형식
        category: '월누계',
        PM2: 190,
        PM3: 240,
        합계: 430,
      },
      {
        date: '2024-08-13', // 유효한 날짜 형식
        category: '월목표',
        PM2: 200,
        PM3: 250,
        합계: 450,
      },
    ],
  },
  {
    machine: '가동율(%)',
    data: [
      { id: 'total-goal', date: '2024-08-13', category: '목표', PM2: 100, PM3: 120, 합계: 220 },
      { id: 'total-performance', date: '2024-08-13', category: '실적', PM2: 90, PM3: 115, 합계: 205 },
      { id: 'total-achievement', date: '2024-08-13', category: '달성율', PM2: -10, PM3: -5, 합계: -15 },
      { id: 'actual-goal', date: '2024-08-13', category: '목표', PM2: 100, PM3: 120, 합계: 220 },
      { id: 'actual-performance', date: '2024-08-13', category: '실적', PM2: 90, PM3: 115, 합계: 205 },
      { id: 'actual-achievement', date: '2024-08-13', category: '달성율', PM2: -10, PM3: -5, 합계: -15 },

      { id: 'total-goal', date: '2024-08-14', category: '목표', PM2: 1010, PM3: 1210, 합계: 2120 },
      { id: 'total-performance', date: '2024-08-14', category: '실적', PM2: 910, PM3: 115, 합계: 2105 },
      { id: 'total-achievement', date: '2024-08-14', category: '달성율', PM2: -101, PM3: -51, 합계: -115 },
      { id: 'actual-goal', date: '2024-08-14', category: '목표', PM2: 1010, PM3: 1210, 합계: 1220 },
      { id: 'actual-performance', date: '2024-08-14', category: '실적', PM2: 901, PM3: 1115, 합계: 2015 },
      { id: 'actual-achievement', date: '2024-08-14', category: '달성율', PM2: -110, PM3: -511, 합계: -115 },
    ],
  },
  {
    machine: 'Utility',
    data: [
      {
        date: '2024-08-13',
        kwusegoal: '27',
        kwuseprice: '12',
        kwtotalusegoal: '2321',
        kwtotaluseprice: '1213',
        kwtotaltonmoneygoal: '5513',
        kwtotaltonmoneyprice: '12',
        kwtotalmoneygoal: '212132',
        kwtotalmoneyprice: '213',
        LNGusegoal: '27',
        LNGuseprice: '12',
        LNGtotalusegoal: '2321',
        LNGtotaluseprice: '1213',
        LNGtotaltonmoneygoal: '5513',
        LNGtotaltonmoneyprice: '12',
        LNGtotalmoneygoal: '212132',
        LNGtotalmoneyprice: '213',
      },
    ],
  },
];
